import {InterfaceControlMenuTreeMobile} from "../interface/control-menu-tree/interface.control.menu.tree.mobile";

export class ControlMenuTreeComponent {
    readonly controlActive: string = 'active';
    private controlMenuItems: HTMLElement[];
    private controlMenuIdItems: HTMLElement[];
    private contentIdItems: HTMLElement[];
    private contentTextMobileItems: HTMLElement[];
    private searchInputItems: HTMLInputElement[];
    private contentTextItems: HTMLElement[];

    constructor(
        private container: HTMLElement,
        private windowWidth: number
    ) {
        this.controlMenuItems =
            Array.prototype.slice.call(this.container.querySelectorAll('[data-control-menu]'));
        this.controlMenuIdItems =
            Array.prototype.slice.call(this.container.querySelectorAll('[data-control-menu-id]'));
        this.contentIdItems =
            Array.prototype.slice.call(this.container.querySelectorAll('[data-content-id]'));
        this.contentTextMobileItems =
            Array.prototype.slice.call(this.container.querySelectorAll('[data-content-text-item-mobile]'));
        this.searchInputItems =
            Array.prototype.slice.call(this.container.querySelectorAll('[data-search]'));
        this.contentTextItems =
            Array.prototype.slice.call(this.container.querySelectorAll('[data-content-text]'));
    }
    public initialize(): void {
        const ul: HTMLUListElement | null = this.container.querySelector('ul');
        if (ul) {
            ul.style.height = 'auto';
        }
        this.controlMenuItems.forEach((controlMenuItem, index) => {
            if (controlMenuItem.classList.contains('active')) {
                const ul: HTMLUListElement | null = controlMenuItem.querySelector('ul')
                if (ul) {
                    ul.style.height = 'auto';
                }
            }
            controlMenuItem.addEventListener('click', (e) => {
                this.windowWidth = window.innerWidth;
                this.resetSearch(this.searchInputItems, this.contentTextItems);
                e.stopImmediatePropagation();
                if (controlMenuItem.dataset.controlMenu && this.windowWidth > 680) {
                    this.controlMenuItems.forEach((controlMenuIdItem) => {
                        if (controlMenuIdItem.dataset.controlMenu !== 'parent') {
                            controlMenuIdItem.classList.remove(this.controlActive);
                        }
                    });
                    if (controlMenuItem.dataset.controlMenu !== 'parent') {
                        controlMenuItem.classList.add(this.controlActive);
                    }
                    if (
                        this.controlMenuIdItems[index].dataset.controlMenuId
                        && parseInt(this.controlMenuIdItems[index].dataset.controlMenuId, 10) === -1
                    ) {
                        this.contentIdItems.forEach((contentIdItem) => {
                            contentIdItem.classList.add(this.controlActive);
                        });
                    } else {
                        if(this.contentIdItems[index - 1].querySelector('[data-content-text]')) {
                            this.contentIdItems.forEach((contentIdItem, index) => {

                                contentIdItem.classList.remove(this.controlActive);
                            });
                        }
                        if (
                            this.contentIdItems[index - 1]?.dataset.contentId
                            === this.controlMenuIdItems[index]?.dataset.controlMenuId
                        ) {
                            if (this.contentIdItems[index - 1].querySelector('[data-content-text]')) {
                                this.contentIdItems[index - 1].classList.add(this.controlActive);
                            }
                        }
                    }
                }
                let currentControlMenuItems: HTMLElement[] = [];
                currentControlMenuItems = this.recursivelyIterateThroughMenuItems(controlMenuItem, []);
                const mobileParams= {
                    controlMenuItem,
                    contentTextMobileItems: this.contentTextMobileItems,
                    controlActive: this.controlActive,
                    currentControlMenuItems,
                    controlMenuItems: this.controlMenuItems,
                    index
                };
                this.mobileManage(mobileParams);
                // controlMenuItem.closest('ul').style.height = 'auto';
                // controlMenuItem.closest('ul').style.height = controlMenuItem.closest('ul').scrollHeight + 'px';
                if (controlMenuItem.dataset.controlMenu === 'parent') {
                    controlMenuItem.classList.toggle(this.controlActive);
                    const height = controlMenuItem.querySelector('ul')?.scrollHeight;
                    const heightContentTextMobile =
                        controlMenuItem.querySelector(
                            '[data-control-menu] [data-content-text-mobile]'
                        )?.scrollHeight;
                    // controlMenuItem.querySelector('[data-control-menu] [data-content-text-mobile]').scrollIntoView();
                    const ul: HTMLUListElement | null = controlMenuItem.querySelector('ul');
                    if (ul) {
                        ul.style.height =
                            (controlMenuItem.classList.contains('active')
                                ? height : 0) + 'px';
                    }
                    const contentTextMobile: HTMLElement | null = controlMenuItem.querySelector(
                        '[data-control-menu] [data-content-text-mobile]'
                    );
                    if (contentTextMobile) {
                        contentTextMobile.style.height = (controlMenuItem.classList.contains('active')
                            ? heightContentTextMobile : 0) + 'px';
                    }
                }
                this.recursiveSetHeight(controlMenuItem.closest('ul'));
                if (controlMenuItem.classList.contains(this.controlActive)) {
                    this.controlMenuItems.forEach((controlMenuItemInternal: HTMLElement, controlMenuItemIndex: number) => {
                        if (
                            controlMenuItemIndex !== index
                        ) {
                            if (!currentControlMenuItems.some(
                                (currentControlMenuItem: HTMLElement ): boolean => currentControlMenuItem
                                    === controlMenuItemInternal
                            )) {
                                controlMenuItemInternal.classList.remove(this.controlActive);
                                const contentTextMobile: HTMLElement | null =
                                    controlMenuItemInternal.querySelector('[data-content-text-mobile]')
                                const ul: HTMLUListElement | null = controlMenuItemInternal.querySelector('ul')
                                if (contentTextMobile) {
                                    contentTextMobile.style.height = '0';
                                    if (ul) {
                                        ul.style.height = '0';
                                    }
                                }
                            }
                        }
                    });
                }
            });
        });
    }
    mobileManage(mobileParams: InterfaceControlMenuTreeMobile) {
        const  {
            controlMenuItem,
            contentTextMobileItems,
            controlActive,
            currentControlMenuItems,
            controlMenuItems,
            index
        } = mobileParams;
        if (this.windowWidth <= 680 && controlMenuItem.dataset.controlMenu !== 'parent') {
            contentTextMobileItems.forEach((contentIdItem) => {
                contentIdItem.classList.add(controlActive);
            });
            const contentTextMobileCurrentItems: NodeListOf<Element> =
                controlMenuItem.querySelectorAll('[data-content-text-mobile]');
            controlMenuItem.classList.toggle(controlActive);

            contentTextMobileCurrentItems.forEach((contentTextMobileItem: Element): void => {
                const contentTextMobileHeight: number = contentTextMobileItem.scrollHeight;
                const contentTextMobileItemCurrent: HTMLElement | null = contentTextMobileItem as HTMLElement;
                if (contentTextMobileItemCurrent) {
                    contentTextMobileItemCurrent.style.height = (controlMenuItem.classList.contains('active')
                        ? contentTextMobileHeight
                        : 0) + 'px';
                }
            })
        }
    }
    resetSearch(searchInputItems: HTMLInputElement[], contentTextItems: HTMLElement[]) {
        searchInputItems.forEach((searchInputItem: HTMLInputElement) => {
            searchInputItem.value = '';
        });
        contentTextItems.forEach(filteredContentTextSimpleItem => {

            filteredContentTextSimpleItem?.classList.add('active');
            if (
                filteredContentTextSimpleItem.closest('ul')
                && filteredContentTextSimpleItem.closest('[data-content-text-mobile]')
            ) {
                const controlMenu: HTMLElement | null = filteredContentTextSimpleItem.closest('[data-control-menu]');
                controlMenu?.classList.remove('active');
            }
        });
    }
    recursivelyIterateThroughMenuItems(controlMenuItemInternal: HTMLElement, items: HTMLElement[]) {
        const ul: HTMLUListElement | null = controlMenuItemInternal.closest('ul')
        if (ul && ul.closest('[data-control-menu]'))
        {
            const controlMenu: HTMLElement | null = ul
                .closest('[data-control-menu]');
            if (controlMenu) {
                this.recursivelyIterateThroughMenuItems(controlMenu, items);
            }
        }
        if (controlMenuItemInternal) {
            items.push(controlMenuItemInternal);
        }

        return items;
    }
    recursiveSetHeight(controlMenuItem: HTMLElement | null) {
        if (controlMenuItem) {
            controlMenuItem.style.height = 'auto';
            controlMenuItem.addEventListener('transitionend', (e) => {
                controlMenuItem.style.height = controlMenuItem.offsetHeight + 'px';
            })
            const controlMenuItemLi: HTMLElement | null = controlMenuItem.closest('li');
            if (controlMenuItemLi) {
                this.recursiveSetHeight(controlMenuItemLi.closest('ul'));
            }
        }
    }
}
